import { getSvYear } from "@/utils/date";

export function getConfiguredSeason() {
  const configured = Number(process.env.REACT_APP_STANDINGS_SEASON);
  return Number.isFinite(configured) && configured > 0
    ? configured
    : getSvYear(new Date());
}

export function resolveSeason(...candidates) {
  for (const candidate of candidates) {
    const value = Number(candidate);
    if (Number.isFinite(value) && value > 0) return value;
  }
  return getConfiguredSeason();
}
